const CLASS_COLORS: Record<string, string> = {
  liquid_can: '#9c27b0',
  hazardous_good_symbol: '#ff9800',
  container: '#2196f3',
  mattress: '#f44336',
  'rolls/tapes/wire': '#795548',
  lamp: '#ffeb3b',
  pressurized_can: '#ff5722',
  accumulator: '#009688',
  mineral_fiber: '#607d8b',
  wood: '#8b4513',
  film: '#e91e63',
  edge_size_over_1m: '#4be250ff',
};

const DEFAULT_COLOR = '#9e9e9e';

export function getColorForClass(className: string): string {
  return CLASS_COLORS[className] ?? DEFAULT_COLOR;
}
